export const getSelectedValues = (values) =>
  values
    .filter((value) => value.selected === true)
    .map(({ label, qty }) => ({ label, qty }));
